import React from "react";
import { Container, Form, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import {
  FetchAreaList,
  DeleteAreaRecord,
} from "../../../services/locationService";
import { useState, useEffect, useRef } from "react";
import { toast } from "react-toastify";

import serach_icon from "../../../assets/images/icon/search-icon.svg";
import delete_icon from "../../../assets/images/icon/delete.svg";
import edit_icon from "../../../assets/images/icon/edit.svg";
import dowanload_csv from "../../../assets/images/icon/downloadcsv.svg";
import right_arrow from "../../../assets/images/icon/right-arrow-table.svg";
import arrow_btn from "../../../assets/images/icon/arrow-btn.svg";

import { CSVLink } from "react-csv";
import { Button } from "reactstrap";
import { downloadCSVReport } from "helpers/backend_helper";
import { getUserInfo } from "helpers/authHelper";
import { checkPermissionStatus } from "helpers/utils";
import { decryptDataFromArray } from "helpers/EncDec";
import { useTranslation } from "react-i18next";

function MasterArea(props) {
  const { t } = useTranslation();
  const [areaData, setareaData] = useState([]);
  const [successMessage, setSuccessMessage] = useState("");
  const [error, setError] = useState("");
  const [query, setQuery] = useState("");
  const userInfo = getUserInfo();
  //tabs
  const [activeTab, setActiveTab] = useState("tab1");
  const handleTabClick = tab => {
    setActiveTab(tab);
  };

  const [csvData, setCSVData] = useState([]);

  const handleCSVDownload = async e => {
    e.preventDefault();
    if (areaData?.length === 0) {
      toast.error(t(`Location_Manager.No data available`));
      return;
    }

    let allData = JSON.parse(JSON.stringify(areaData)) || [];
    allData = allData?.map(el => {
      el.statusText = el?.status === 1 ? "Active" : "Inactive";
      return el;
    });

    try {
      setCSVData(allData || []);
      setTimeout(() => {
        let element = document.getElementById("downloadCSV");
        element.click();
      }, 1000);
    } catch (err) {}
  };

  useEffect(() => {
    getAreaList();
    document.title = "NeuroTal - Area List";
  }, []);

  const getAreaList = async () => {
    FetchAreaList()
      .then(res => {
        let response = decryptDataFromArray(res?.data);
        if (response?.status) {
          let data = response?.data;
         // data = data.filter(item => item.status === 1);
          setareaData(data);
        } else {
          toast.error(t(`Location_Manager.No data available`));
        }
      })
      .catch(err => {
        toast.error(t(`Location_Manager.No data available`));
      });
  };

  // Bootstrap table columns
  const handleCheck = (e, app_id) => {
    let value = e.target.checked;
    let allAreas = areaData?.map(el => {
      if (el?.area_id === app_id) {
        el.checked = value;
      }
      return el;
    });
    setareaData(allAreas);
  };

  let columns = [
    // {
    //   dataField: "area_id",
    //   text: "Area Id",
    //   classes: "total",
    //   formatter: (cellContent, row) => {
    //     return (
    //       <div className="date-tabel">
    //         {/* <input
    //           defaultChecked={row?.checked || false}
    //           onClick={e => handleCheck(e, row?.id)}
    //           type="checkbox"
    //         /> */}
    //         <label>{row.id}</label>
    //       </div>
    //     );
    //   },
    // },
    {
      dataField: "serial_no",
      text: t(`Location_Manager.Serial No`),
      formatter: (cellContent, row, rowIndex) => {
        return rowIndex + 1; // Serial number starts from 1
      },
    },
    {
      dataField: "area_name",
      text: t(`Location_Manager.Area Name`),
      classes: "area-name ",
    },
    {
      dataField: "status",
      text: t(`Location_Manager.Status`),
      classes: "area-status ",
      formatter: (cell, row) => {
        return cell === 1
          ? t(`Location_Manager.Active`)
          : t(`Location_Manager.Inactive`);
      },
    },
  ];

  if (checkPermissionStatus("area-list", "edit")) {
    columns.push({
      dataField: "",
      text: t(`Location_Manager.Actions`),
      formatter: (cell, row) => {
        let area_id = row.id;

        return (
          <div className="d-flex gap-1 blue-icon-gap action-application">
            <div className="action-one small-img">
              <Link
                className="text-success blue-icon blue-color4"
                to={`/edit-area/${area_id}`}
                // title="Edit Region"
              >
                <img src={edit_icon} alt="edit_icon" />
                <span>{t(`Location_Manager.Edit Area`)}</span>
              </Link>
            </div>

            {/* <div className="action-one small-img">
              <Link
                to="#"
                onClick={() => handleRejectedRecords(area_id)}
                className="blue-color3"
              >
                <img src={delete_icon} alt="delete_icon" />
                <span>{t(`Location_Manager.Delete`)}</span>
              </Link>
            </div> */}
          </div>
        );
      },
    });
  }
  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      {t(`Location_Manager.Showing rows`, { from, to, size })}
    </span>
  );
  let options = {
    paginationSize: 1,
    pageStartIndex: 1,
    alwaysShowAllBtns: true, // Always show next and previous button
    withFirstAndLast: true, // Hide the going to First and Last page button
    hideSizePerPage: true, // Hide the sizePerPage dropdown always
    hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
    firstPageText: false,
    prePageText: false,
    nextPageText: false,
    lastPageText: false,
    nextPageTitle: "Next page",
    prePageTitle: "Pre page",
    firstPageTitle:"First page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: false,
  };
  // Delete Faqs
  const handleRejectedRecords = area_id => {
    DeleteAreaRecord(area_id)
      .then(res => {
        let responseData = res?.data;
        responseData = decryptDataFromArray(responseData);
        if (res?.status == 200) {
          let messages = toast.success(responseData?.message);
          getAreaList();
          // window.location.reload();
        } else {
          toast.error(responseData?.message);
          ref.current?.scrollIntoView({ behavior: "smooth" });
        }
      })
      .catch(error => {
        console.log(error);
      });
  };

  //rohit-code//

  const options2 = {
    paginationSize: 1,
    pageStartIndex: 1,
    alwaysShowAllBtns: true, // Always show next and previous button
    withFirstAndLast: true, // Hide the going to First and Last page button
    hideSizePerPage: true, // Hide the sizePerPage dropdown always
    hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
    firstPageText: false,
    prePageText: false,
    nextPageText: false,
    lastPageText: false,
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: false,
    totalSize: areaData.length,
  };

  const renderCheck = el => {
    if (!query) {
      return true;
    }
    let searchItem = JSON.stringify(el)?.toLowerCase();
    if (searchItem?.includes(query?.toLowerCase())) {
      return true;
    }
    return false;
  };

  const rowClasses = (row, rowIndex) => {
    return rowIndex % 2 === 0 ? "even-row" : "odd-row";
  };

  
  const tableWrapperRef = useRef(null);
  const handleScroll = direction => {
    if (tableWrapperRef.current) {
      const scrollAmount = 100; // Adjust this value as needed
      tableWrapperRef.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };

  useEffect(() => {
    const theme = localStorage.getItem("company_theme");
    if (theme) {
      document.body.classList.add(`theme-${theme}`);
    }
  }, []);

  if (!checkPermissionStatus("area-list", "view")) {
    return (
      <div className="page-content">
        <h4 className="text-center">{t(`Location_Manager.Access Denied`)}</h4>
      </div>
    );
  }

  return (
    <>
      <div className="pending-list-page feedbacks departmentpage">
        <div className="tab-content" id="pills-tabContent">
          {/* <div className="joblist-container arealist">
            <Row className="mb-2 align-items-center py-2 depart-content">
              <Col sm="8" className="Joblist-column">
                <h5 className="text-uppercase heading-one">
                  {t(`Location_Manager.Area List`)}
                </h5>
              </Col>
            </Row>
          </div> */}

          <div className="joblist-container create-vacancy main-pages-s">
            <Row className="mb-2 align-items-center">
              <Col lg="6" md="6" className="Joblist-column">
                <Link to="/dashboard">
                  <h5 className="text-uppercase heading-one">
                    <img src={arrow_btn} alt="arrow_btn" />
                    {t(`Location_Manager.Area List`)}
                  </h5>
                </Link>
              </Col>
            </Row>
          </div>

          <div className="outerTab-box-wrapper below-vacancy  amsterresign  applicationcard-table">
            <div className="region-list-page aploc">
              <div
                className="tab-pane fade show active"
                id="pills-home"
                role="tabpanel"
                // aria-labelledby="pills-home-tab"
              >
                <div className="tabel-area table-responsive tabel-application tabel-application-auto  pb-3">
                  <div className="table-data-search frenchise-list">
                    <div className="total-record">
                      <h5>
                        {t(`Location_Manager.Total Records`)}{" "}
                        <span>{areaData?.length || 0}</span>
                      </h5>
                    </div>
                    <div className="total-serachbar">
                      <div className="serach-bar-top">
                        <form class="form-inline">
                          <input
                            class="form-control mr-sm-2"
                            type="search"
                            placeholder={t(`Location_Manager.Search by Area`)}
                            aria-label="Search"
                            value={query}
                            onChange={e => setQuery(e.target.value)}
                          />
                          <span>
                            <img src={serach_icon} alt="search" />
                          </span>
                        </form>
                      </div>
                      {checkPermissionStatus("area-list", "downloadcsv") && (
                        <div className="take-text">
                          <CSVLink
                            data={csvData}
                            headers={[
                              {
                                key: "id",
                                label: t(`Location_Manager.Area ID`),
                              },
                              {
                                key: "area_name",
                                label: t(`Location_Manager.Area Name`),
                              },
                              {
                                key: "statusText",
                                label: t(`Location_Manager.Status`),
                              },
                            ]}
                            filename={`areaList.csv`}
                            id="downloadCSV"
                          >
                            <Button
                              color="info"
                              onClick={e => handleCSVDownload(e)}
                              outline
                            >
                              <img src={dowanload_csv} alt="Download" />
                              {t(`Location_Manager.Download CSV`)}
                            </Button>
                          </CSVLink>
                        </div>
                      )}

                      {checkPermissionStatus("area-list", "create") && (
                        <Link to="/create-area" className="btn btn-primary">
                          {t(`Location_Manager.Create Area`)}
                        </Link>
                      )}

                      <div className="tale-text right-panel mobile-arrow mb-0">
                        <button
                          className="button left"
                          onClick={() => handleScroll("left")}
                          data-tooltip="Scroll Left"
                        >
                          <img src={right_arrow} alt="right-arrow" />
                        </button>
                        <button
                          className="button right"
                          onClick={() => handleScroll("right")}
                          data-tooltip="Scroll Right"
                        >
                          <img src={right_arrow} alt="right-arrow" />
                        </button>
                      </div>
                    </div>
                  </div>

                  {/* <div className="timeto-hire-card userlist  when-data-low  masterstate-cards"> */}
                  <div className="timeto-hire-card userlist pendiglist-cardss">
                    <div className="table-custome-class range-custome">
                      <div className="scroll-container">
                        <div className="table-pending-list">
                          {areaData?.length > 0 && (
                            <div
                              className="table-wrapper"
                              ref={tableWrapperRef}
                            >
                              <BootstrapTable
                                keyField="id"
                                data={areaData?.filter(renderCheck)}
                                columns={columns}
                                pagination={paginationFactory(options)}
                                rowClasses={rowClasses}
                                hover
                                responsive
                              />
                            </div>
                          )}

                          {areaData?.length === 0 && (
                            <>
                              <div className="no-data data-available">
                                <img
                                  src="../img/data-not-available.png"
                                  alt="data not availble"
                                />
                                <h3> {t(`Location_Manager.No Item Found`)}</h3>
                                <p>
                                  {t(
                                    `Location_Manager.Sorry, we could not find any`
                                  )}
                                  <br />{" "}
                                  {t(`Location_Manager.Item to show here`)}
                                </p>
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="area-list-page d-none">
        <Container fluid>
          <Row className="mb-3">
            <Col sm="6">
              <h5 className="text-uppercase">area List </h5>
            </Col>

            <Col
              sm="6"
              style={{
                display: "flex",
                justifyContent: "flex-end",
              }}
            ></Col>
          </Row>
          {successMessage && (
            <div class="alert alert-success" role="alert">
              {successMessage}
            </div>
          )}

          <Row>
            <div className="area-list-page">
              <div className="tabbing-wrapper d-flex justify-content-between mt-2 mb-4">
                <div className="tab-head d-flex align-items-lg-center justify-content-lg-between">
                  <ul className="tab-btn-wrapper d-flex align-items-center">
                    <li>
                      <Link
                        href="javascript:void()"
                        className="tab-link active"
                        id="current-month"
                      >
                        Current Month
                      </Link>
                    </li>
                    <li>
                      <Link
                        href="javascript:void()"
                        className="tab-link"
                        id="last-month"
                      >
                        Last 3 Months
                      </Link>
                    </li>
                    <li>
                      <Link
                        href="javascript:void()"
                        className="tab-link"
                        id="custom"
                      >
                        Custom
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="tab-content">
                {activeTab === "tab1" && (
                  <div className="tab-pane show active">
                    <ToolkitProvider
                      keyField="head1"
                      data={areaData}
                      columns={columns}
                      search
                    >
                      {props => (
                        <div>
                          <BootstrapTable
                            {...props.baseProps}
                            pagination={paginationFactory()}
                            options={options}
                            striped
                            hover
                          />
                        </div>
                      )}
                    </ToolkitProvider>
                  </div>
                )}
                {activeTab === "tab2" && (
                  <div className="tab-pane show active">
                    <p>Content of Tab 2</p>
                  </div>
                )}
                {/* Add more tab content as needed */}
              </div>
            </div>
          </Row>
        </Container>
      </div>
    </>
  );
}

export default MasterArea;
